import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Center, Spinner } from '@chakra-ui/react';
import { useFetchServiceProductDetailQuery } from 'rtkQuery/sharespro/queries/services';
import ServiceProductDetailLoaded from 'presentation/components/modules/products/detail/ServiceProductDetailLoaded';
import ServiceProductApplyCard from 'presentation/components/modules/products/detail/ServiceProductApplyCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import AppCard from 'presentation/components/shared/card/AppCard';
import { useUpdateEffect } from 'react-use';

const ServiceProductDetailPage: FC = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const parsedId = +(id as string);

  const { data, error, refetch, isFetching } =
    useFetchServiceProductDetailQuery(parsedId);

  useUpdateEffect(() => {
    refetch();
  }, [i18n.language]);

  let content;
  let hasData = false;
  if (data) {
    content = <ServiceProductDetailLoaded data={data} />;
    hasData = true;
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (!hasData) {
    content = (
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <ActivesPageLayout
      sidebarContent={
        data?.contentAction && (
          <ServiceProductApplyCard
            productId={data.id}
            productName={data.title}
          />
        )
      }
    >
      <Helmet>
        <title>{data?.title ?? t('productsTitle')}</title>
      </Helmet>
      {content}
    </ActivesPageLayout>
  );
};

export default ServiceProductDetailPage;
